import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/Footer/Footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/ScrollProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/app/context/AuthContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/vercel/path0/app/context/CartContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/vercel/path0/app/context/ToastContext.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"900\"],\"variable\":\"--font-poppins\",\"display\":\"swap\",\"preload\":true,\"fallback\":[\"system-ui\",\"arial\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
